import { Dialog } from "primereact/dialog"
import { useState } from "react"
import styles from "../../../styles/Participant-GPRA.module.css"
import FormLabel from "../Common/FormLabel"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { SECTIONS } from "../types/interviewTypes"
import { InputSwitch } from "primereact/inputswitch"
import FormError from "../Common/FormError"
import { Button } from "primereact/button"
import { errorMessages } from "../types/messages"
import { existsErrors } from "../utils/utils"
import { useContext, useEffect } from "react"
import { UserContext } from "../../../context/userContext"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"

const AddMatrix = ({
  show,
  setShow,
  interviewType,
  section,
  organizations,
  selectedOrganizations,
  number,
  matrixEditing,
  questions,
  updateQuestions,
}) => {
  const userCtx = useContext(UserContext)
  const [matrixModified, setMatrixModified] = useState({
    id: 0,
    title: "",
    editing: false,
    enabled: true,
    expanded: true,
  })
  const [validationErrors, setValidationErrors] = useState({})
  const [saving, setSaving] = useState(false)
  useEffect(() => {
    if (matrixEditing) {
      setMatrixModified(matrixEditing)
    }
  }, [matrixEditing])

  const clearValues = () => {
    setMatrixModified({
      title: "",
      enabled: true,
      required: true,
      id: 0,
      oldTitle: "",
    })
    setValidationErrors({})
  }
  const validationForm = () => {
    let errors = {}
    if (!matrixModified.title) {
      errors.title = errorMessages.requiredMessage
    }
    if (matrixModified.id === 0 || !matrixModified.id) {
      if (matrixModified.title !== matrixModified.oldTitle) {
        if (
          questions?.matrices
            .filter((q) => q.section === section && q.form === interviewType)
            .some((q) => q.title === matrixModified.title)
        ) {
          errors.title = "This title it's already in use"
        }
      }
    } else {
      if (
        matrixModified.title !== matrixModified.additionalOldTitle &&
        questions?.matrices.find((q) => q.id === matrixModified.id)?.title !==
          matrixModified.title &&
        questions?.matrices
          .filter((q) => q.section === section && q.form === interviewType)
          .some((q) => q.title === matrixModified.title)
      ) {
        errors.title = "This title it's already in use"
      }
    }
    setValidationErrors(errors)
    return existsErrors(errors)
  }
  const renderFooter = () => {
    return (
      <>
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={() => {
              setShow(false)
              clearValues()
            }}
            className="p-button-text"
          />
          <Button
            label="Save"
            icon={
              saving && Object.entries(validationErrors)?.length === 0
                ? "pi pi-spin pi-spinner"
                : "pi pi-save"
            }
            onClick={() => {
              saveMatrix()
            }}
            autoFocus
          />
        </div>
      </>
    )
  }
  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }
  const getNumber = () => {
    if (section === INTERVIEW_SECTIONS.SUBSTANCE_USE_2) {
      return number + 1
    }
    if (section === INTERVIEW_SECTIONS.SUBSTANCE_USE_3) {
      return number + 5
    }
    if (section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_5) {
      return number + 1
    }
    return number
  }
  const saveMatrix = () => {
    setSaving(true)
    if (validationForm()) {
      let newSave = []
      if (matrixModified.editing) {
        newSave = questions?.matrices?.map((q) => {
          let newValue = { ...q }
          if (
            newValue.title === matrixModified.oldTitle &&
            q.section === section &&
            q.form === interviewType
          ) {
            newValue.enabled = matrixModified.enabled
            newValue.oldTitle = matrixModified.oldTitle
            newValue.expanded = matrixModified.expanded
            newValue.title = matrixModified.title
            newValue.questionGroups = matrixModified.questionGroups
          }
          return newValue
        })
      } else {
        const newMatrix = {
          id: matrixModified.id,
          organizationUuid: userCtx.session.user.organization_id,
          form: interviewType,
          section: section,
          title: matrixModified.title,
          oldTitle: matrixModified.title,
          enabled: matrixModified.enabled,
          expanded: matrixModified.expanded,
          number: getNumber(),
          organizations: organizations,
          selectedOrganizations: selectedOrganizations,
        }
        newSave = [...questions?.matrices, newMatrix]
      }
      const updatedMatrices = newSave?.map((m) => {
        let newValue = { ...m }
        let updatedGroups
        if (newValue?.questionGroups?.length > 0) {
          updatedGroups = newValue?.questionGroups.map((g) => {
            let newGroup = { ...g }
            let newMatrixGroup = { ...g.matrixGroup }
            newMatrixGroup.title = newValue.title
            newMatrixGroup.enabled = matrixModified.enabled
            newMatrixGroup.expanded = matrixModified.expanded
            newGroup.matrixGroup = newMatrixGroup
            newGroup.matrixId = matrixModified.title
            return newGroup
          })
        }
        newValue.questionGroups = updatedGroups
        return newValue
      })
      const updatedGroups = questions?.groups?.map((g) => {
        let newValue = { ...g }
        if (matrixModified.oldTitle) {
          if (g.matrixGroup?.title === matrixModified.oldTitle) {
            let updatedMatrixGroup = { ...g.matrixGroup }
            updatedMatrixGroup.title = matrixModified.title
            updatedMatrixGroup.matrixId = matrixModified.title
            updatedMatrixGroup.enabled = matrixModified.enabled
            updatedMatrixGroup.expanded = matrixModified.expanded
            newValue.matrixGroup = updatedMatrixGroup
            newValue.enabled = !matrixModified.enabled
              ? matrixModified.enabled
              : newValue.enabled
          }
        }
        return newValue
      })
      updateQuestions({
        ...questions,
        matrices: updatedMatrices,
        groups: updatedGroups,
      })
      setSaving(false)
      clearValues()
      setShow(false)
    }
  }
  return (
    <Dialog
      header={`${matrixModified.id !== 0 ? "Edit" : "Add"} matrix`}
      visible={show}
      onHide={() => setShow(false)}
      breakpoints={{ "960px": "40vw" }}
      style={{ width: "35vw" }}
      footer={renderFooter()}
      closable={false}
      blockScroll={true}
    >
      <div className={styles.modalGrid}>
        <div className={styles.formRow}>
          <FormLabel label={"Form"} />
          <InputText
            value={interviewType}
            disabled
            className={styles.inputText7}
          />
        </div>
        <div className={styles.formRow}>
          <FormLabel label={"Section"} />
          <Dropdown
            value={section}
            optionLabel="label"
            optionValue="value"
            disabled
            options={SECTIONS}
            className={styles.input7}
          />
        </div>
        <div className={styles.formRow}>
          <FormLabel label={"Title"} />
          <InputText
            value={matrixModified?.title}
            onChange={(e) => {
              setMatrixModified({
                ...matrixModified,
                title: e.target.value,
              })
              removeError("title")
            }}
            className={
              validationErrors?.title
                ? styles.inputText7Error
                : styles.inputText7
            }
          />
          <FormError error={validationErrors?.title} errorType={2} />
        </div>
        <div className={styles.formRow}>
          <div style={{ marginTop: "20px" }}>
            <label className={styles.ml1} htmlFor="binary">
              Enabled
            </label>
            <InputSwitch
              style={{ verticalAlign: "text-top", marginLeft: "7rem" }}
              checked={matrixModified?.enabled}
              onChange={(e) => {
                setMatrixModified({
                  ...matrixModified,
                  enabled: e.value,
                })
              }}
            />
          </div>
        </div>
        <div className={styles.formRow}>
          <div style={{ marginTop: "20px" }}>
            <label className={styles.ml1} htmlFor="binary">
              Expanded
            </label>
            <InputSwitch
              style={{ verticalAlign: "text-top", marginLeft: "6.25rem" }}
              checked={matrixModified?.expanded}
              onChange={(e) => {
                setMatrixModified({
                  ...matrixModified,
                  expanded: e.value,
                })
              }}
            />
          </div>
        </div>
      </div>
    </Dialog>
  )
}
export default AddMatrix
